<template>
  <RCard class="chart" :class="dark ? 'bg-graph-8' : 'bg-white-1'" :style="{ '--height': height }">
    <slot name="header">
      <Grid gtc="1fr auto" align-items="center" class="header">
        <div :class="dark ? 'text-white-1' : 'text-secondary-1'">
          <div class="text-body-3 text-ellipsis">{{ title }}</div>
          <div class="text-body-1">{{ subtitle }}</div>
        </div>

        <div>
          <slot name="widget-options"></slot>
        </div>
      </Grid>
    </slot>

    <slot>
      <Grid v-if="!chartData" justify-content="center" align-items="center" class="full-height">
        <q-spinner color="primary" size="2.5em" />
      </Grid>

      <template v-else>
        <slot name="before-chart"></slot>
        <Chart :options="chartData" :style="{ height: chartHeight }" />
      </template>
    </slot>
  </RCard>
</template>

<script>
import { Chart } from 'highcharts-vue'

export default {
  components: {
    Chart
  },

  props: {
    title: String,

    subtitle: String,

    dark: Boolean,

    height: {
      type: String,
      default: '350px'
    },

    chartHeight: {
      type: String,
      default: '100%'
    },

    chartData: [Object, null] // not required, cuz if we pass null indicates download
  }
}
</script>

<style lang="scss" scoped>
.chart {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: var(--r-space-md);
  height: var(--height);

  > * + * {
    align-self: end;
  }
}
</style>
